import { IDVGItemDTO, IGenericDTO } from "coreframetypings/dto";
import { IReadOnlyPrinterStatic } from '#/DefaultViewExtensionInterfaces';
import { staticImplements } from '@/Components/@Decorator/StaticImplementsDecorator';
import CurrencyHelper from '@/Utility/CurrencyHelper';
import Utilities from '@/Utility/Utilities';

@staticImplements<IReadOnlyPrinterStatic>()
export default class CurrencyPrinter {

    public static print(item: IDVGItemDTO, value: string, row: IGenericDTO): HTMLElement {
        let span = document.createElement('span');
        span.textContent = CurrencyPrinter.createText(item, value, row);
        return span;
    }

    public static isRelevant(item: IDVGItemDTO, value: string, row: IGenericDTO): boolean {
        return item.dotNetTypeName === 'RAD.RADFoundation.ProblemDomain.Financial.CurrencyT'
            || item.parent?.dotNetTypeName === 'RAD.RADFoundation.ProblemDomain.Financial.CurrencyT';
    }

    public static createToolTip(item: IDVGItemDTO, value: string, row: IGenericDTO): string {
        return CurrencyPrinter.createText(item, value, row);
    }

    private static createText(item: IDVGItemDTO, value: string, row: IGenericDTO): string {
        if (!value)
            return '';

        const propertyName = CurrencyPrinter.getPropertyName(item);
        const currencyProperty = propertyName + "." + 'CurrencyID';
        const currencyId = row.values[currencyProperty];
        if (Utilities.isNullOrUndefinedOrBlank(currencyId))
            return '';

        const currencyValue = CurrencyHelper.toClientValue(parseFloat(value));
        return CurrencyHelper.toCurrencyString(currencyValue, currencyId);
    }

    private static getPropertyName(item: IDVGItemDTO) : string {
        const index = item.name.indexOf(".");
        if (index <= 0)
            return item.name;

        return item.name.substring(0, index);
    }
}